(ns practitest.frontend.components.comments
  (:require
    [ajax.core :as ajax]
    [practitest.frontend.routing.backend-routes :as broutes]
    [reagent.core :as reagent]
    [tick.core :as tick]
    [clojure.string :as str]
    [practitest.frontend.components.users :as users]
    [practitest.frontend.components.tooltip :as tooltip]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components.spinners :as spinners]
    [practitest.frontend.common.mixpanel :as mixpanel]
    [practitest.frontend.common.dom :as dom]
    [practitest.frontend.events :as events]
    [practitest.frontend.components.notifications :as notifications]
    [practitest.frontend.components.markdown :as markdown]
    [practitest.frontend.subs :as subs]
    [re-frame.core :as re-frame]
    [re-frame.db]))


;; TODO: separate namespace for comments
(comment
  {:comments-view {:editor {1 {:editing? true
                               :value    "new-body"
                               :dirty?   false}}}})

;; Subs

;; Parent subscription
(re-frame/reg-sub
  ::comments-editor-state
  (fn [db [_ state-key comment-id]]
    (or (get-in db [:comments-view :editor state-key comment-id])
        {})))

;; Children subscriptions
(re-frame/reg-sub
  ::editing-comment?
  (fn [[_ state-key comment-id]]
    (re-frame/subscribe [::comments-editor-state state-key comment-id]))
  (fn [state _]
    (boolean (:editing? state))))

(re-frame/reg-sub
  ::comment-editor-value
  (fn [[_ state-key comment-id]]
    (re-frame/subscribe [::comments-editor-state state-key comment-id]))
  (fn [state _]
    (:value state)))

(re-frame/reg-sub
  ::comment-editor-dirty?
  (fn [[_ state-key comment-id]]
    (re-frame/subscribe [::comments-editor-state state-key comment-id]))
  (fn [state _]
    (:dirty? state)))

;; Events
(re-frame/reg-event-db
  ::start-edit-comment
  (fn [db [_ state-key {:keys [id body] :as comment}]]
    (update-in db
               [:comments-view :editor state-key id]
               assoc
               :editing? true
               :dirty? false
               :value body)))

(defn- redispatch
  [value & args]
  (when value
    (if (vector? value)
      (apply conj value args)
      (apply conj [value] args))))

(re-frame/reg-event-db
  ::stop-edit-comment
  (fn [db [_ state-key id]]
    (assoc-in db [:comments-view :editor state-key id] {})))

(re-frame/reg-event-db
  ::on-change-comment-value
  (fn [db [_ state-key id value]]
    (-> db
        (update-in [:comments-view :editor state-key id]
                   assoc
                   :value value
                   :dirty? true))))

(defn saved-comment [{db :db} [_
                               {:keys [state-key
                                       on-comment-edited-dispatch]
                                :as   props}
                               id
                               data]]
  {:db         (update db :progress disj [::save-comment state-key id])
   ;; TODO: update comment in local db
   :dispatch-n [[::stop-edit-comment state-key id]
                [::notifications/success "Comment saved" {:auto-close 1000}]
                (redispatch on-comment-edited-dispatch id data)]})

(re-frame/reg-event-fx
  ::saved-comment
  saved-comment)

(defn save-comment [{db :db} [_
                              {:keys [state-key]
                               :as   props}
                              id value]]
  {:db (update db :progress conj [::save-comment state-key id])
   :http-xhrio
   {:method          :put
    :uri             (broutes/get-url "comments#update"
                                      {:project_id (subs/get-current-project-id db)
                                       :id id})
    :params          {:body value}
    :format          (ajax/json-request-format)
    :response-format (ajax/raw-response-format)
    :on-success      [::saved-comment props id]
    :on-failure      [::events/api-error [::save-comment state-key id] {:message "Error saving comment"}]}})

(re-frame/reg-event-fx
  ::save-comment
  save-comment)

(defn deleted-comment [{db :db} [_
                                 {:keys [state-key
                                         on-comment-deleted-dispatch]
                                  :as   props}
                                 id
                                 data]]
  {:db         (update db :progress disj [::delete-comment state-key id])
   ;; TODO: remove comment from local db
   :dispatch-n [[::notifications/success "Comment deleted" {:auto-close 1000}]
                (redispatch on-comment-deleted-dispatch id data)]})

(re-frame/reg-event-fx
  ::deleted-comment
  deleted-comment)

(defn delete-comment [{db :db} [_
                                {:keys [state-key]
                                 :as   props}
                                id]]
  (let [progress-path [::delete-comment state-key id]]
    {:db (update db :progress conj progress-path)
     :http-xhrio
     {:method          :delete
      :uri             (broutes/get-url "comments#destroy"
                                        {:project_id (subs/get-current-project-id db)
                                         :id id})
      :format          (ajax/url-request-format)
      :response-format (ajax/raw-response-format)
      :on-success      [::deleted-comment props id]
      :on-failure      [::events/api-error progress-path {:message "Error deleting comment"}]}}))

(re-frame/reg-event-fx
  ::delete-comment
  delete-comment)

(defn added-comment [{db :db} [_
                               {:keys [state-key
                                       on-comment-added-dispatch]
                                :as   props}
                               data]]
  {:db         (update db :progress disj [::add-comment state-key])
   :dispatch-n [[::stop-edit-comment state-key :new]
                [::notifications/success "Comment added" {:auto-close 1000}]
                (redispatch on-comment-added-dispatch data)]})

(re-frame/reg-event-fx
  ::added-comment
  added-comment)

(defn add-comment [{db :db} [_
                             {:keys [state-key
                                     entity-type
                                     entity-id]
                              :as   props}
                             value]]
  {:db (update db :progress conj [::add-comment state-key])
   :http-xhrio
   {:method          :post
    :uri             (broutes/get-url "comments#create"
                                      {:project_id (subs/get-current-project-id db)})
    :params          {:comment        value
                      :table_name     (case entity-type
                                        :testset
                                        "suites"
                                        :step
                                        "step_designs")
                      :commentable_id entity-id}
    :format          (ajax/json-request-format)
    :response-format (ajax/raw-response-format)
    :on-success      [::added-comment props]
    :on-failure      [::events/api-error [::add-comment state-key] {:message "Error adding comment"}]}})

(re-frame/reg-event-fx
  ::add-comment
  add-comment)

;; TODO: autoresize ?
(defn comment-editor
  [_]
  (reagent/create-class
    {:component-did-mount (fn [comp]
                            ;; autofocus
                            (let [node (reagent.dom/dom-node comp)]
                              (.focus node)))

     :reagent-render      (fn [{:keys [on-change
                                       value
                                       users]
                                :as   props}]
                            [markdown/tribute-textarea
                             {:class               "form-control"
                              :on-change           on-change
                              :on-tribute-replaced (fn [e]
                                                     (when on-change
                                                       (on-change e)))

                              ;; TODO: pass from backend
                              :max-length          5000
                              :value               value
                              :users               users}])}))

;; TODO: save on ctrl+enter ?
(defn- on-key-down-handler
  [state-key id e]
  (when (= "Escape" (.-code e))
    (re-frame/dispatch [::stop-edit-comment state-key id])))

(defn- format-timestamp
  [ts]
  (when ts
    (.toLocaleString ^js (tick/inst ts))))

(defn heading-button
  [props body]
  [:button.btn.btn-sm.btn-outline-pt-secondary.ms-auto
   props
   body])

(defn- comment-body
  [body]
  (let [parts (partition-all 2 (str/split body #"\[~(.*?)\]" -1))]
    (into [:div.comment-body]
          (mapcat
            (fn [[text email]]
              [text
               (when email
                 [:span.mention-hl email])])
            parts))))

;; see comments-element props - they are passed here as is
(defn comment-element
  [{:keys [users-query
           current-user-query
           state-key
           enable-comments]
    :as   props}
   {:keys [id user_id body created_at updated_at] :as comment}]
  (let [users        @(re-frame/subscribe users-query)
        current-user @(re-frame/subscribe current-user-query)
        saving?      @(re-frame/subscribe [::subs/progress? [::save-comment state-key id]])
        deleting?    @(re-frame/subscribe [::subs/progress? [::delete-comment state-key id]])
        editing?     @(re-frame/subscribe [::editing-comment? state-key id])
        dirty?       @(re-frame/subscribe [::comment-editor-dirty? state-key id])
        value        @(re-frame/subscribe [::comment-editor-value state-key id])
        user         (users/find-user users user_id)]

    [:div.comment-element
     [:div.comment-controls
      (when enable-comments
        (if (= (:id current-user) user_id)
          [tooltip/hover-tooltip
           "Edit comment"
           [:span.clickable.me-1
            {:on-click (fn [e]
                         (when-not (or deleting?
                                       saving?)
                           (re-frame/dispatch [::start-edit-comment state-key comment])))}
            [icons/pencil-fill]]]

        ;; Placeholder
          [:span.me-1
           [icons/empty-icon]]))
      (when enable-comments
        (if (= (:id current-user) user_id)
          [tooltip/hover-tooltip
           "Remove comment"
           [:span.clickable.me-1
            {:on-click (fn [e]
                         (when-not (or deleting?
                                       saving?)
                         ;; TODO: something better
                           (when (js/confirm "Are you sure you want to remove the comment?")
                             (re-frame/dispatch [::delete-comment props id]))))}
            (if deleting?
              [spinners/inline-spinner-border]
              [icons/svg-trash])]]

        ;; Placeholder
          [:span.me-1
           [icons/empty-icon]]))

      [users/user-avatar user]]
     [:div.comment-contents
      [:div.comment-header
       [:strong
        (:name user)
        " at "
        (format-timestamp created_at)

        (when (and (some? updated_at)
                   (not= updated_at created_at))
          (str " (edited at " (format-timestamp updated_at) ")"))]]

      (if editing?
        [:div.form-group
         {:on-key-down (reagent/partial on-key-down-handler state-key id)}
         [:div.mb-2
          [comment-editor
           {:on-change (fn [e]
                         (re-frame/dispatch-sync [::on-change-comment-value state-key id (dom/event-value e)]))
            :value     (or value "")
            :users     (filter #(= "user" (:type %)) users)}]]
         [:div.btn-group
          [:button.btn.btn-sm.btn-primary
           {:disabled (or (not dirty?)
                          saving?)
            :on-click (fn [e]
                        (re-frame/dispatch [::save-comment props id value]))}

           (when saving?
             [:span.me-1
              [spinners/inline-spinner-border]])

           "Save"]
          [:button.btn.btn-sm.btn-outline-pt-secondary
           {:on-click (fn [e]
                        (re-frame/dispatch [::stop-edit-comment state-key id]))
            :disabled saving?}
           "Cancel"]]]
        [comment-body body])]]))

(defn- prepare-props
  [{:keys [entity-type
           entity-id]
    :as   props}]

  (assert entity-type "Entity type is required")
  (assert entity-id "Entity ID is required")

  (let [state-key (str entity-type "-" entity-id)
        options   @(re-frame/subscribe [::subs/options])]
    (merge {:users-query        [::subs/users]
            :current-user-query [::subs/current-user]}
           props
           {:state-key state-key})))

;; Re-frame component - uses re-frame events  and queries in props (vectors)
(defn comments-control
  [props]
  (let [{:keys [;; Required props
                data-query
                fetch-progress-query
                small_screen
                entity-type
                entity-id
                enable-comments
                ;; Calculated in prepare-props
                state-key

                ;; Props with defaults
                users-query

                on-comment-added-dispatch
                on-comment-edited-dispatch
                on-comment-deleted-dispatch]
         :as   props} (prepare-props props)
        fetching-comments?  @(re-frame/subscribe fetch-progress-query)
        comments            @(re-frame/subscribe data-query)
        adding-comment?     @(re-frame/subscribe [::editing-comment? state-key :new])
        new-value           @(re-frame/subscribe [::comment-editor-value state-key :new])
        saving-new-comment? @(re-frame/subscribe [::subs/progress? [::add-comment state-key]])
        users               @(re-frame/subscribe users-query)]
    [:<>
     [:div.section-header
      (if (= small_screen 1)
      [:h4 {:style {:font-size "18px" :color "var(--pt-color-primary)"}} "Comments"] [:h3 "Comments"])
      (when enable-comments
       (when-not adding-comment?
         [heading-button
          {:on-click (fn ([e]
                          (mixpanel/track "Add Comment" {"Entity" (name entity-type)})
                          (re-frame/dispatch [::start-edit-comment
                                           state-key
                                           {:id   :new
                                            :body ""}])))}
          "Add comment"]))]

     ;; TODO: reuse comment-component here ?
     (when adding-comment?
       [:div.new-comment
        {:on-key-down (reagent/partial on-key-down-handler state-key :new)}

        [:div.mb-2
         [comment-editor
          {:on-change (fn [e]
                        (re-frame/dispatch-sync [::on-change-comment-value state-key :new (dom/event-value e)]))
           :users     (filter #(= "user" (:type %)) users)
           :value     (or new-value "")}]]
        [:div.btn-group
         [:button.btn.btn-sm.btn-primary
          {:disabled (or saving-new-comment?
                         (str/blank? new-value))
           :on-click (fn [e]
                       (re-frame/dispatch [::add-comment
                                           props
                                           new-value]))}

          (when saving-new-comment?
            [:span.me-1
             [spinners/inline-spinner-border]])

          "Add comment"]
         [:button.btn.btn-sm.btn-outline-pt-secondary
          {:disabled saving-new-comment?
           :on-click (fn [e]
                       (re-frame/dispatch [::stop-edit-comment state-key :new]))}
          "Cancel"]]])

     (when fetching-comments?
       [spinners/overlay-spinner])
     (if (= small_screen 1)
       (into [:ul.small-list-group]
           (for [c comments]
             ^{:key (str (:id c))}
             [:li.list-group-item {:style {:word-break "break-word"}}  [comment-element props c]]))
       (into [:ul.list-group]
           (for [c comments]
             ^{:key (str (:id c))}
             [:li.list-group-item [comment-element props c]])))]))
